(() => {
  const media = window.matchMedia('(max-width: 767px)');
  const init = (root = document) => {
    root.querySelectorAll('[data-gl2-footer-group]').forEach(group => {
      if (group.dataset.footerReady) return;
      group.dataset.footerReady = 'true';
      const summary = group.querySelector('summary');
      if (!summary) return;
      const update = () => {
        if (!media.matches || !group.contains(document.activeElement)) group.open = !media.matches;
        summary.tabIndex = media.matches ? 0 : -1;
        summary.setAttribute('aria-expanded', String(group.open));
      };
      summary.addEventListener('click', event => { if (!media.matches) event.preventDefault(); });
      group.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(group.open)));
      media.addEventListener('change', update);
      update();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
